// extracted by mini-css-extract-plugin
export default {"search":"Search_search__i0h93","searchBox":"Search_searchBox__OnzLL","focused":"Search_focused__InHM+"};